import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { Asset } from '@/types/asset';
import type { ApiQueryParams } from '@/types/apiQuery';
import { EndpointResponse } from '@/types/endpoints';
import { utils } from '@/utils';
import type { ReadRequestOptions } from '../requestOptions';

type RequestParams = Pick<ApiQueryParams, 'limit' | 'page'>;

type Response = Asset[];

export const getAssets = async (
  scope: RequestScope,
  { limit = 1000, page = 1 }: RequestParams = {},
  options: ReadRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    const result = await scopedApi(scope).get<EndpointResponse<Response>>(`assets?sort=created_at:-1&limit=${limit}&page=${page}`, options);
    return result.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
